import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Divider } from 'components/_new/Divider';

export const TopCardsSkeleton = () => {
	return (
		<>
			<div className="flex flex-column gap-1">
				<Skeleton width="16rem" height="2rem" className="mb-2" />
				<div className="grid">
					{[1, 2, 3, 4, 5, 6].map((i) => (
						<div key={i} className="flex flex-column col-12 sm:col-6 md:col-4">
							<div
								className="flex flex-column gap-2 p-3 border-round surface-border"
								style={{
									border: '1px solid var(--surface-border)',
									backgroundColor: 'var(--surface-card)',
								}}
							>
								<div className="flex gap-3 align-items-center">
									<Skeleton shape="circle" size="3rem" />
									<Skeleton width="60%" height="1.5rem" />
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
			<Divider />
		</>
	);
};
